/* Senteurs en mouvement — Bougie Frenchie.
   Modes : « drag » (glisser au doigt ou à la souris, flèches), « autoplay » (avance seule, s'arrête au survol
   et dès qu'on interagit), « marquee » (défilement continu, senteurs dupliquées côté navigateur).
   Rien ne bouge si l'appareil limite les animations ; pas de défilement continu dans l'éditeur de thème. */
if (!customElements.get('bf-scents')) {
  const reduce = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class BfScents extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-sc-viewport]');
      this.track = this.querySelector('[data-sc-track]');
      if (!this.viewport || !this.track) return;
      this.bar = this.querySelector('[data-sc-bar]');
      this.prev = this.querySelector('[data-sc-prev]');
      this.next = this.querySelector('[data-sc-next]');
      const design = window.Shopify && window.Shopify.designMode;
      const motion = this.dataset.motion;

      this.addEventListener('click', (e) => {
        if (this.dragged) { e.preventDefault(); e.stopPropagation(); return; }
        if (e.target.closest('a, button')) return;
        const card = e.target.closest('[data-href]');
        if (card && !design) window.location.href = card.dataset.href;
      }, true);

      if (motion === 'marquee' && !reduce() && !design) { this.setupMarquee(); return; }
      this.setupScroll();
      if (motion === 'autoplay' && !reduce()) this.startAuto();
    }

    disconnectedCallback() { clearInterval(this.timer); }

    cards() { return Array.from(this.track.querySelectorAll('.bf-scent')); }

    step() {
      const c = this.cards()[0];
      if (!c) return this.viewport.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return c.getBoundingClientRect().width + gap;
    }

    go(dir) {
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      const behavior = reduce() ? 'auto' : 'smooth';
      if (dir > 0 && this.viewport.scrollLeft >= max - 4) this.viewport.scrollTo({ left: 0, behavior });
      else if (dir < 0 && this.viewport.scrollLeft <= 4) this.viewport.scrollTo({ left: max, behavior });
      else this.viewport.scrollBy({ left: dir * this.step(), behavior });
    }

    setupScroll() {
      if (this.prev) this.prev.addEventListener('click', () => { this.stopAuto(); this.go(-1); });
      if (this.next) this.next.addEventListener('click', () => { this.stopAuto(); this.go(1); });
      this.viewport.addEventListener('scroll', () => this.update(), { passive: true });
      window.addEventListener('resize', () => this.update(), { passive: true });
      this.update();

      /* Glisser à la souris (le tactile utilise le défilement natif) */
      let startX = 0; let startLeft = 0; let down = false;
      this.viewport.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; this.dragged = false; startX = e.clientX; startLeft = this.viewport.scrollLeft;
        this.stopAuto();
      });
      window.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        if (!this.dragged && Math.abs(dx) > 6) { this.dragged = true; this.viewport.classList.add('is-dragging'); }
        if (this.dragged) this.viewport.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', () => {
        if (!down) return;
        down = false;
        if (this.dragged) {
          this.viewport.classList.remove('is-dragging');
          const s = this.step();
          this.viewport.scrollTo({ left: Math.round(this.viewport.scrollLeft / s) * s, behavior: reduce() ? 'auto' : 'smooth' });
          setTimeout(() => { this.dragged = false; }, 50);
        }
      });
      this.viewport.addEventListener('touchstart', () => this.stopAuto(), { passive: true });
      this.viewport.addEventListener('dragstart', (e) => e.preventDefault());
    }

    update() {
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      const left = this.viewport.scrollLeft;
      if (this.bar) this.bar.style.width = (this.viewport.scrollWidth ? ((left + this.viewport.clientWidth) / this.viewport.scrollWidth) * 100 : 100) + '%';
      if (this.dataset.motion === 'drag') {
        if (this.prev) this.prev.disabled = left <= 4;
        if (this.next) this.next.disabled = left >= max - 4;
      }
    }

    startAuto() {
      const delay = parseInt(this.dataset.interval, 10) || 4000;
      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });
      this.addEventListener('focusin', () => { this.paused = true; });
      this.addEventListener('focusout', () => { this.paused = false; });
      this.timer = setInterval(() => { if (!this.paused && !document.hidden) this.go(1); }, delay);
    }

    stopAuto() { clearInterval(this.timer); this.timer = null; }

    setupMarquee() {
      const cards = this.cards();
      if (cards.length < 2) return;
      cards.forEach((c) => {
        const copy = c.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        copy.removeAttribute('id');
        this.track.appendChild(copy);
      });
      this.classList.add('is-marquee');
    }
  }
  customElements.define('bf-scents', BfScents);
}
